(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dl-howto"] && !Shopify.designMode) return;
  try {
    
/* Scoped to each guide instance — no document-wide IDs or class sweeps. */
(function () {
  function wire(root) {
    if (root.dataset.dlGuideReady === '1') return;
    root.dataset.dlGuideReady = '1';

    var btns = root.querySelectorAll('[data-dl-guide-tab]');
    var panels = root.querySelectorAll('[data-dl-guide-panel]');
    if (!btns.length) return;

    Array.prototype.forEach.call(btns, function (btn) {
      btn.addEventListener('click', function () {
        var want = btn.getAttribute('data-dl-guide-tab');

        Array.prototype.forEach.call(btns, function (b) {
          var on = b === btn;
          b.classList.toggle('active', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });

        Array.prototype.forEach.call(panels, function (p) {
          var on = p.getAttribute('data-dl-guide-panel') === want;
          p.classList.toggle('active', on);
          if (!on) {
            var v = p.querySelector('video');
            if (v && !v.paused) v.pause();
          }
        });
      });
    });
  }

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-dl-guide]');
    Array.prototype.forEach.call(roots, wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dl-spec"] && !Shopify.designMode) return;
  try {
    
/* Per-section carousel. The original kept a single module-level index and
   used global function names plus a fixed element id, so a second instance
   on the page would drive the first one. This keeps state per section. */
(function () {
  function wire(root) {
    if (root.dataset.dlSpecReady === '1') return;
    root.dataset.dlSpecReady = '1';

    var track  = root.querySelector('[data-dl-spec-track]');
    var slides = root.querySelectorAll('.loomi-carousel-slide');
    var tabs   = root.querySelectorAll('.loomi-spec-tab');
    var dots   = root.querySelectorAll('.loomi-dot');
    var total  = slides.length;
    if (!track || total === 0) return;

    var current = 0;

    function show(i) {
      current = ((i % total) + total) % total;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      Array.prototype.forEach.call(slides, function (s, idx) {
        s.classList.toggle('active', idx === current);
      });
      Array.prototype.forEach.call(tabs, function (t, idx) {
        var on = idx === current;
        t.classList.toggle('active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      Array.prototype.forEach.call(dots, function (d, idx) {
        d.classList.toggle('active', idx === current);
      });
    }

    Array.prototype.forEach.call(root.querySelectorAll('[data-dl-spec-go]'), function (el) {
      el.addEventListener('click', function () {
        show(parseInt(el.getAttribute('data-dl-spec-go'), 10) || 0);
      });
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-dl-spec-move]'), function (el) {
      el.addEventListener('click', function () {
        show(current + (parseInt(el.getAttribute('data-dl-spec-move'), 10) || 0));
      });
    });

    show(0);
  }

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-dl-spec-carousel]');
    Array.prototype.forEach.call(roots, wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
